import api from '@/utils/http/axios'

export default {
  /**
  * 获取交易核查状态列表
  */
  getStatusList (params = {}, config = {}) {
    return api.get('/cbi-ls-corporbank/api/corporbank/statusList', params, {
      ...config
    })
  },
  /**
  * 获取交易核列表
  */
  getCheckTableData (params = {}, config = {}) {
    return api.post('/cbi-ls-corporbank/api/corporbank/list', params, {
      ...config
    })
  },
  /**
  * 获取交易核查详情
  * @param {string} receiptFlowNo
  */
  getCheckDetails (params = {}, config = {}) {
    return api.post('/cbi-ls-corporbank/api/corporbank/details', params, {
      ...config
    })
  },
  /**
  * 申报
  * @param {string} receiptFlowNo 单号
    @param {string} remittanceCompanyNature 汇款人企业性质
    @param {string} relation 与汇款人关系
    @param {string} remitterPurpose: 汇款用途/目的,
    @param {string} fileInfoList 资金证明材料
  */
  goToDeclare (params = {}, config = {}) {
    return api.post('/cbi-ls-corporbank/api/corporbank/update', params, {
      ...config
    })
  }
}
